import React from 'react'
import { Button, Modal, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../util/IntlMessages'

const { Paragraph } = Typography

const DATE_FORMAT = { year: 'numeric', month: 'long', day: 'numeric' } as const

const LOST_FEATURE_MESSAGE_IDS = [
  'completeBoost.warning.labels',
  'completeBoost.warning.leavePolicies',
  'completeBoost.warning.workHours',
  'completeBoost.warning.departments',
  'completeBoost.warning.addons',
]

export const PlanBoostLostFeatures = (): React.ReactElement => (
  <ul>
    {LOST_FEATURE_MESSAGE_IDS.map((id) => (
      <li key={id}>
        <IntlMessages id={id} />
      </li>
    ))}
  </ul>
)

interface IPlanBoostEndingWarningModalProps {
  expiresAt: string
  onClose: () => void
  onUpgrade: () => void
}

export const PlanBoostEndingWarningModal = ({ expiresAt, onClose, onUpgrade }: IPlanBoostEndingWarningModalProps): React.ReactElement => {
  const { formatDate } = useIntl()

  return (
    <Modal
      open
      title={<IntlMessages id="completeBoost.warning.title" />}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          <IntlMessages id="app.close" />
        </Button>,
        <Button key="upgrade" type="primary" onClick={onUpgrade}>
          <IntlMessages id="completeBoost.upgradeToComplete" />
        </Button>,
      ]}
    >
      <Paragraph>
        <IntlMessages id="completeBoost.warning.description" values={{ date: formatDate(expiresAt, DATE_FORMAT) }} />
      </Paragraph>
      <PlanBoostLostFeatures />
      <Paragraph>
        <IntlMessages id="completeBoost.warning.upgradeHint" />
      </Paragraph>
    </Modal>
  )
}
